<div fxLayout="column"
     fxLayoutAlign="space-around center"
     class="password-page">

    <div class="form-wrapper"
         fxLayout="column"
         fxLayoutAlign="space-between center">
        <img src="assets/images/full-logo.svg"
             class="login-logo"
             alt="SalesRun Logo">

        <div fxLayout="row">
            <form [formGroup]="passwordForm"
                  class="password-form"
                  novalidate>
                <div fxLayout="column"
                     fxLayoutAlign="center center">
                    <p class="password-hint">To reset your password, please enter your SalesRun
                        Username<br> and press 'Request Change':</p>
                </div>
                <div fxLayout="row"
                     fxLayoutAlign="center center">
                    <mat-icon svgIcon="mdi:account">
                    </mat-icon>
                    <mat-form-field [srpAsterisk]>
                        <input matInput
                               type="text"
                               srpNoAutocomplete
                               formControlName="userName"
                               placeholder="User Name">
                        <mat-error *ngIf="!passwordForm.controls.userName.valid && (passwordForm.controls.userName.dirty || passwordForm.controls.userName.touched)"
                                   class="password-error">
                            <span *ngIf="passwordForm.controls.userName.hasError('required')">User Name is
                                required</span>
                            <span *ngIf="passwordForm.controls.userName.hasError('customError')">{{ errorMsg }}</span>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row"
                     fxLayoutAlign="space-between center"
                     class="password-button_panel">
                    <a mat-button
                       color="accent"
                       [routerLink]="['']">Back to Login</a>
                    <button mat-raised-button
                            color="accent"
                            [disabled]="!passwordForm.controls.userName.valid || loading"
                            (click)="request()">{{loading ? 'Requesting...' : 'Request Change'}}</button>
                </div>
            </form>
        </div>
    </div>
</div>